module.exports = __webpack_public_path__ + "BK2HvS7Z2Q.png";


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/CommonCell/components/GoodItem/asset/grabGrayImg.png
// module id = 743
// module chunks = 438